export const images = {
  eiLogo: "/img/logo-ei.png",
  whiteEiLogo: "/img/white-logo-ei.png",
  dovetailLogo: "/img/logo-dovetail.png",
  imiLogo: "/img/logo-imi.png",
  programOverview: "/img/programme-overview.png",
  preReadingImgUrl: "/img/preReadingThumb.png",
  workshopTemplatesImgUrl: "/img/workshopTemplates.png",
  workshopMaterialsImgUrl: "/img/workshopMaterials.png",
  strategyClarificationWorkshopImgUrl: "/img/strategyClarificationWorkshop2.png",
  criticalSkillsWorkshopImgUrl: "/img/criticalSkillsWorkshop.png",
  programmeGuideImgUrl: "/img/programmeGuide.png",
};
